import { notificationsInlineAdd, notificationsInlineRemove } from 'Notifications/NotificationsInline/actions'
import { NOTIFICATIONS_INLINE_OVER_LIMIT_COUNT } from 'Notifications/NotificationsInline/constants'

function getStore () {
  return require('store').default
}

function getActiveNotifications () {
  const notifications = getStore().getState().notificationsInline.notifications
  return notifications.filter(n => n.active)
}

export function notifyRaw (payload) {
  return getStore().dispatch(notificationsInlineAdd(payload))
}

export function notify (title, options) {
  if (!options) {
    options = {
      type: 'success'
    }
  }

  options.priority = 'high'
  options.title = title
  return getStore().dispatch(notificationsInlineAdd(options))
}

export function notifyWithLimit (title, options) {
  if (!options) {
    options = {
      type: 'success'
    }
  }

  options.priority = 'high'
  options.title = title
  const limit = options.limit || NOTIFICATIONS_INLINE_OVER_LIMIT_COUNT
  const activeNotifications = getActiveNotifications()
  if (activeNotifications.length >= limit) {
    const oldestNotification = activeNotifications[0]
    getStore().dispatch(notificationsInlineRemove(oldestNotification.uuid))
  }
  return getStore().dispatch(notificationsInlineAdd(options))
}
